import { ChangeDetectionStrategy, Component } from '@angular/core';
import { PwaUpdateService } from '../../services/pwa-update.service';

@Component({
  selector: 'ngx-pwa-update-banner',
  templateUrl: './pwa-update-banner.component.html',
  styleUrls: ['./pwa-update-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PwaUpdateBannerComponent {
  readonly notice$ = this.updates.notice$;
  confirmingDiscard = false;

  constructor(private updates: PwaUpdateService) {}

  update(): void {
    if (this.updates.hasUnsavedChanges()) {
      this.confirmingDiscard = true;
      return;
    }
    this.updates.requestReload();
  }

  discardAndUpdate(): void {
    if (this.updates.requestReload(true)) this.confirmingDiscard = false;
  }
}
